import React, { useState } from "react";

const ProductCard = ({ product, onSelect }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const name = product?.shortName || product?.name || "Unnamed Product";
  const productId = product?.variantId || "";
  const dosage = product?.dosageCode || product?.dosageDisplay || "";
  const type = product?.type || "";
  const imageUrl = product?.primaryImage || null;

  return (
    <div className="revamp-product-card" onClick={() => onSelect(product)}>
      <div className="revamp-product-card__image-container">
        {!imageLoaded && !imageError && (
          <div className="revamp-product-card__image-placeholder" />
        )}
        {imageUrl && !imageError ? (
          <img
            src={imageUrl}
            alt={name}
            className={`revamp-product-card__image ${imageLoaded ? "revamp-product-card__image--loaded" : ""}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
            loading="lazy"
          />
        ) : (
          <div className="revamp-product-card__image-fallback">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </div>
        )}
      </div>
      <div className="revamp-product-card__content">
        <h4 className="revamp-product-card__name">{name}</h4>
        <div className="revamp-product-card__details">
          {productId && (
            <span className="revamp-product-card__detail-value">{productId}</span>
          )}
          {dosage && (
            <span className="revamp-product-card__detail-value revamp-product-card__detail-value--dosage">{dosage}</span>
          )}
          {type && (
            <span className="revamp-product-card__detail-value revamp-product-card__detail-value--type">{type}</span>
          )}
        </div>
      </div>
      <div className="revamp-product-card__hover-indicator">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </div>
    </div>
  );
};

export default ProductCard;
